import { useConfig } from '@oviva-ag/configuration';
import { Config } from '@/types/config.types';
import {
  GOOGLE_PLACES_API,
  GTM_AUTH_KEY,
  GTM_ID,
  GTM_PREVIEW_ID,
  NEWRELIC_APP_ID,
} from '@/utils/constants';

interface UseEnvVariable {
  newrelicAppId: string;
  googlePlacesKey: string;
  gtmId: string;
  gtmPreviewId: string;
  gtmAuthKey: string;
  gtmServerUrl: string;
}

const useEnvVariable = (): UseEnvVariable => {
  const { config } = useConfig<Config>();
  const newrelicAppId = config?.newrelic_app_id || NEWRELIC_APP_ID;
  const googlePlacesKey = config?.google_places_api_key || GOOGLE_PLACES_API;
  const gtmId = config?.gtm_id || GTM_ID;
  const gtmPreviewId = config?.gtm_preview_id || GTM_PREVIEW_ID;
  const gtmAuthKey = config?.gtm_auth_key || GTM_AUTH_KEY;
  const gtmServerUrl = config?.gtm_server_url;

  return {
    newrelicAppId,
    googlePlacesKey,
    gtmId,
    gtmPreviewId,
    gtmAuthKey,
    gtmServerUrl,
  };
};

export default useEnvVariable;
